/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meow Mobile API
 * MeowStore 모바일 백엔드 API 명세
 * OpenAPI spec version: v1.0.0
 */
import type {
  MainMarkItemListResponse,
  MissionInfoResponse,
  MissionRewardClaimResponse,
  TodayGameUserCountResponse,
} from '.././model';

/**
 * path의 tier(1 또는 2)에 해당하는 보상만 요청합니다. 1단계: 250P 이상 시 간식 10, 2단계: 500P 이상 시 간식 25. 미션 주기당 단계별 1회만 수령 가능합니다.
 * @summary 오퍼월 미션 단계별 간식 수령
 */
export type claimOfferwallMissionSnacksResponse200 = {
  data: MissionRewardClaimResponse;
  status: 200;
};

export type claimOfferwallMissionSnacksResponseSuccess = claimOfferwallMissionSnacksResponse200 & {
  headers: Headers;
};
export type claimOfferwallMissionSnacksResponse = claimOfferwallMissionSnacksResponseSuccess;

export const getClaimOfferwallMissionSnacksUrl = (tier: number) => {
  return `/main/missionReward/snack/${tier}`;
};

export const claimOfferwallMissionSnacks = async (
  tier: number,
  options?: RequestInit,
): Promise<claimOfferwallMissionSnacksResponse> => {
  const res = await fetch(getClaimOfferwallMissionSnacksUrl(tier), {
    ...options,
    method: 'POST',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: claimOfferwallMissionSnacksResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as claimOfferwallMissionSnacksResponse;
};

/**
 * 현재 미션 주기 시작 시점과 Offerwall 누적 포인트를 반환합니다.
 * @summary 미션 정보 조회
 */
export type getMissionInfoResponse200 = {
  data: MissionInfoResponse;
  status: 200;
};

export type getMissionInfoResponseSuccess = getMissionInfoResponse200 & {
  headers: Headers;
};
export type getMissionInfoResponse = getMissionInfoResponseSuccess;

export const getGetMissionInfoUrl = () => {
  return `/main/missionInfo`;
};

export const getMissionInfo = async (options?: RequestInit): Promise<getMissionInfoResponse> => {
  const res = await fetch(getGetMissionInfoUrl(), {
    ...options,
    method: 'GET',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getMissionInfoResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as getMissionInfoResponse;
};

/**
 * 메인 마크 영역에 노출되는 상품 최대 3건을 순서대로 반환합니다.
 * @summary 메인 마크 상품 목록 조회
 */
export type getMainMarkItemListResponse200 = {
  data: MainMarkItemListResponse;
  status: 200;
};

export type getMainMarkItemListResponseSuccess = getMainMarkItemListResponse200 & {
  headers: Headers;
};
export type getMainMarkItemListResponse = getMainMarkItemListResponseSuccess;

export const getGetMainMarkItemListUrl = () => {
  return `/main/mainMarkItemList`;
};

export const getMainMarkItemList = async (options?: RequestInit): Promise<getMainMarkItemListResponse> => {
  const res = await fetch(getGetMainMarkItemListUrl(), {
    ...options,
    method: 'GET',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getMainMarkItemListResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as getMainMarkItemListResponse;
};

/**
 * 오늘(서버 기준) 냥냥펀치(game_punch_event)와 타임냥(game_time_nyang_play_history) 플레이 사용자를 집계합니다.
 * @summary 오늘 게임 진행 사용자 수 조회
 */
export type getTodayGameUserCountResponse200 = {
  data: TodayGameUserCountResponse;
  status: 200;
};

export type getTodayGameUserCountResponseSuccess = getTodayGameUserCountResponse200 & {
  headers: Headers;
};
export type getTodayGameUserCountResponse = getTodayGameUserCountResponseSuccess;

export const getGetTodayGameUserCountUrl = () => {
  return `/main/game/today-users`;
};

export const getTodayGameUserCount = async (options?: RequestInit): Promise<getTodayGameUserCountResponse> => {
  const res = await fetch(getGetTodayGameUserCountUrl(), {
    ...options,
    method: 'GET',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getTodayGameUserCountResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as getTodayGameUserCountResponse;
};
